import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Header.css';

const Header = ({ showUserSection = true }) => {
  const [scrolled, setScrolled] = useState(false);
  const { currentUser, logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  const handleLogoClick = () => {
    navigate('/');
  };

  return (
    <header className={`site-header ${scrolled ? 'scrolled' : ''}`}>
      <div className="header-container">
        <div className="header-logo" onClick={handleLogoClick}>
          <img src="/logo-L.png" alt="Living Chess" />
        </div>

        <nav className="header-nav">
          <a href="https://livingchess.net/team" className="nav-link">Team</a>
          <a href="https://livingchess.net/news" className="nav-link">News</a>
          <a href="https://livingchess.net/support" className="nav-link">Support</a>
          <a href="https://livingchess.net/techlab" className="nav-link">TechLab</a>
          <a href="https://livingchess.net/blog" className="nav-link">Blog</a>
        </nav>

        <div className="header-actions">
          {showUserSection && currentUser ? (
            <>
              <span className="user-name">{currentUser?.displayName || currentUser?.email}</span>
              <button onClick={handleLogout} className="glass-button">
                Logout
              </button>
            </>
          ) : (
            <>
              <a href="https://livingchess.net/get-involved" className="glass-button">
                Get Involved
              </a>
            </>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
